var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPerk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#0A3355"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9147 34.3915L47.0151 33.0493L41.0966 19.701C40.6822 18.7663 39.3178 18.7663 38.9034 19.701L32.9849 33.0492L18.0853 34.3915C17.042 34.4854 16.6205 35.7457 17.4075 36.4173L28.6493 46.0091L25.3594 60.1869C25.129 61.1797 26.2329 61.9585 27.1337 61.4391L40 54.0189L52.8663 61.4391C53.7672 61.9587 54.8709 61.1797 54.6407 60.1869L51.3506 46.0091L62.5925 36.4173C63.3796 35.7457 62.9579 34.4854 61.9147 34.3915Z",
    fill: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPerk);
export default __webpack_public_path__ + "static/media/New_perk.51dc96bf8860ede910ff4f1a280fb8ad.svg";
export { ForwardRef as ReactComponent };